function changeVariant(mediaID){
  // need to get current image
  var allImg =  document.querySelectorAll('img[src*="/products/"]');

  console.log(mediaID)

  //loop through all variants
  for(variant in product_variant_map)
  {
    if (mediaID == product_variant_map[variant].featured_media.id){
      //get Variant Color
      var color = product_variant_map[variant].option1
      break;
    }
    
    
  }


  // buttons
  var content = document.getElementsByClassName("product-form__color-swatches")[0]
  var buttons = content.getElementsByTagName('button');  

  for(var i = 0, len = buttons.length; i < len; i++) {   
    console.log("Button: " +  buttons[i]);
    if (buttons[i].classList.contains("selected")){
      //buttons[i].classList.remove("selected")
      continue;
    }
    if (buttons[i].dataset.button == color){
      buttons[i].click();
      //better click it
  }
  
}

}

function disableSoldOutVariants(){

    //default for available products:

    // get current color
    let color = document.getElementsByClassName('product__color-swatch selected')[0].getAttribute("data-button");
    console.log("current color: " + color)
  
    // loop through size buttons
    let content = document.getElementsByClassName("product-form__chips")[0]
    let buttons = content.getElementsByTagName('button');  
  
      for(var i = 0, len = buttons.length; i < len; i++) {   
        let combinationAvailable=false
        //some default styles for all buttons here (in case they were changed before by script):
        buttons[i].style.display = 'inline-block';
        buttons[i].disabled = false;
        for(variant in product_variant_map)
        {
          //console.log(product_variant_map[variant].inventory_quantity + " " + product_variant_map[variant].option1 + " " + product_variant_map[variant].option2 )
          //option1 == color 
          //option2 == size
          if ( product_variant_map[variant].option1 == color && product_variant_map[variant].option2 == buttons[i].getAttribute("data-button")){
            // found the variant (right color/size) for this button
            combinationAvailable=true
            buttons[i].style.textDecoration='none'

            if ( product_variant_map[variant].inventory_quantity == 0){
              //combination is available but out of stock
              buttons[i].style.textDecoration='line-through'
            }
          }
        }

        if ( combinationAvailable == false){
          // combination unavailable (we could not find this size combination in the array): hidde this button
          //console.log("disable button with size " + buttons[i].getAttribute("data-button") + " in color " + color)
          buttons[i].disabled = true;
          buttons[i].style.display = 'none';

          
        }
      }
        
  }